
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const Impressum = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <h1 className="text-2xl font-bold mb-6 text-chrona-text">Impressum</h1>
      
      <Card className="border-chrona-gray-800 bg-chrona-gray-900/60 mb-6">
        <CardHeader className="border-b border-chrona-gray-800">
          <CardTitle className="text-chrona-text">Angaben gemäß § 5 TMG</CardTitle>
        </CardHeader>
        <CardContent className="pt-6">
          <div className="space-y-4 text-chrona-gray-300">
            <p>
              CHRONA GmbH<br />
              Buchungsstraße 42<br />
              10115 Berlin<br />
              Deutschland
            </p>
            
            <p>
              <strong className="text-chrona-text">Vertreten durch:</strong><br />
              Max Mustermann, Geschäftsführer
            </p>
            
            <p>
              <strong className="text-chrona-text">Kontakt:</strong><br />
              Telefon: +49 (0) 30 1234567<br />
              E-Mail: support@chrona.it
            </p>
            
            <p>
              <strong className="text-chrona-text">Registereintrag:</strong><br />
              Eingetragen im Handelsregister.<br />
              Registergericht: Amtsgericht Berlin-Charlottenburg<br />
              Registernummer: HRB 123456
            </p>
            
            <p>
              <strong className="text-chrona-text">Umsatzsteuer-ID:</strong><br />
              Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz: DE123456789
            </p>
          </div>
        </CardContent>
      </Card>
      
      <Card className="border-chrona-gray-800 bg-chrona-gray-900/60 mb-6">
        <CardHeader className="border-b border-chrona-gray-800">
          <CardTitle className="text-chrona-text">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</CardTitle>
        </CardHeader>
        <CardContent className="pt-6">
          <div className="space-y-4 text-chrona-gray-300">
            <p>
              Max Mustermann<br />
              Buchungsstraße 42<br />
              10115 Berlin<br />
              Deutschland
            </p>
          </div>
        </CardContent>
      </Card>
      
      <Card className="border-chrona-gray-800 bg-chrona-gray-900/60">
        <CardHeader className="border-b border-chrona-gray-800">
          <CardTitle className="text-chrona-text">Haftung für Inhalte</CardTitle>
        </CardHeader>
        <CardContent className="pt-6">
          <div className="space-y-4 text-chrona-gray-300">
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen 
              Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, 
              übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf 
              eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p>
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen 
              bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer 
              konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese 
              Inhalte umgehend entfernen.
            </p>
            
            <h3 className="text-lg font-medium text-chrona-text">Haftung für Links</h3>
            <p>
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. 
              Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten 
              Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden 
              zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt 
              der Verlinkung nicht erkennbar.
            </p>
            <p>
              Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer 
              Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
            </p>
            
            <h3 className="text-lg font-medium text-chrona-text">Urheberrecht</h3>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. 
              Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes 
              bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind 
              nur für den privaten, nicht kommerziellen Gebrauch gestattet.
            </p>
            <p>
              Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. 
              Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung 
              aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir 
              derartige Inhalte umgehend entfernen.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Impressum;
